// src/utils/cloneDeep.ts
function e(t, n = /* @__PURE__ */ new WeakMap()) {
	if (typeof t != "object" || !t || typeof t == "function") return t;
	if (n.has(t)) return n.get(t);
	if (t instanceof Date) return new Date(t.getTime());
	if (t instanceof RegExp) return new RegExp(t.source, t.flags);
	if (typeof Element < "u" && t instanceof Element || typeof Node < "u" && t instanceof Node) return t;
	if (t instanceof Map) {
		let r = /* @__PURE__ */ new Map();
		return n.set(t, r), t.forEach((t, i) => {
			r.set(i, e(t, n));
		}), r;
	}
	if (t instanceof Set) {
		let r = /* @__PURE__ */ new Set();
		return n.set(t, r), t.forEach((t) => {
			r.add(e(t, n));
		}), r;
	}
	if (Array.isArray(t)) {
		let r = [];
		n.set(t, r);
		for (let i = 0; i < t.length; i++) r[i] = e(t[i], n);
		return r;
	}
	if (typeof t == "object") {
		if ("current" in t && Object.keys(t).length === 1) return t;
		let r = Object.create(Object.getPrototypeOf(t));
		n.set(t, r);
		let i = Object.keys(t);
		for (let a = 0; a < i.length; a++) {
			let o = i[a], s = Object.getOwnPropertyDescriptor(t, o);
			if (s && !s.get && !s.set && s.enumerable) try {
				r[o] = e(t[o], n);
			} catch {
				r[o] = t[o];
			}
		}
		let a = Object.getOwnPropertySymbols(t);
		for (let i = 0; i < a.length; i++) {
			let o = a[i], s = Object.getOwnPropertyDescriptor(t, o);
			if (s && s.enumerable) try {
				r[o] = e(t[o], n);
			} catch {
				r[o] = t[o];
			}
		}
		return r;
	}
	return t;
}
export { e as cloneDeep, e as default };

//# sourceMappingURL=cloneDeep.js.map